import { alpha, InputLabel, Stack, Switch, SwitchProps } from '@mui/material';
import React, { ReactNode } from 'react';
import TooltipHardened from '../TooltipHardened';

interface Props {
  label: string;
  value: boolean;
  tooltip?: ReactNode;
  onChange: (value: boolean) => void;
}

export const StyledSwitch = ({
  label,
  value,
  tooltip,
  onChange,
  ...props
}: Props & Omit<SwitchProps, 'checked' | 'color'>): React.JSX.Element => (
  <TooltipHardened arrow tooltip={tooltip}>
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      onClick={() => {
        onChange(!value);
      }}
      sx={(theme) => ({
        height: 56,
        borderRadius: 1,
        border: 1,
        borderColor: value ? theme.palette.primary.main : alpha(theme.palette.text.primary, 0.23),
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
          borderColor: value ? theme.palette.primary.main : alpha(theme.palette.text.primary, 0.87),
        },
      })}
    >
      <InputLabel
        sx={{
          position: 'relative',
          transform: 'none',
          color: 'text.secondary',
          fontSize: '1rem',
          cursor: 'pointer',
          userSelect: 'none',
          pl: 1,
        }}
      >
        {label}
      </InputLabel>
      <Switch {...props} checked={value} color={'success'} />
    </Stack>
  </TooltipHardened>
);
